import { XOctagonIcon } from "lucide-react";
import React from "react";

import { cn } from "@/lib/utils";

interface NoDataMessageProps {
	message: string | React.ReactNode;
	retrySuggestion?: string;
	className?: string;
	icon?: React.ReactNode;

	style?: React.CSSProperties;
}

export const defaultNoDataIcon = <XOctagonIcon size={24} className="text-icon" />;

export const NoDataMessage = (props: NoDataMessageProps) => {
	return (
		<div className={cn("text-sm text-subtle", props.className)} style={props.style}>
			<div className="flex items-center justify-center gap-2">
				{props.icon}
				{props.message}
			</div>
			{props.retrySuggestion && <div className="flex justify-center">{props.retrySuggestion}</div>}
		</div>
	);
};
